const keys = require('./env/keys')

export const HEADERS = keys.headers
export const JSON_CONTENT = keys.jsonHeader
export const API_BASE_URL = keys.apiBaseUrl
export const AUTH_BASE_URL = keys.authBaseUrl
export const ACCESS_TOKEN = 'accessToken'
export const OAUTH2_REDIRECT_URI = keys.redirectUri
export const GOOGLE_AUTH_URL = API_BASE_URL +
  '/user/oauth2/authorize/google?redirect_uri=' + OAUTH2_REDIRECT_URI
